import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'rcp-file-preview-image',
  styleUrls: ['./file-preview-image.component.scss'],
  template: ` <img [src]="previewFileURL" /> `,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class FilePreviewImageComponent {
  @Input()
  previewFileURL: string;
}
